import React, { useRef, useEffect, useState } from "react";

const ImageReveal = ({ 
  src, 
  alt = "", 
  className = "", 
  objectFit = "cover",
  aspectRatio = "auto"
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setIsVisible(true);
          setHasAnimated(true);
        }
      },
      {
        threshold: 0.1, // Trigger when 10% of the image is visible
        rootMargin: "0px 0px 100px 0px" // Trigger earlier, 100px before image enters viewport
      }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, [hasAnimated]);

  return (
    <div 
      ref={imageRef} 
      className={`image-reveal-container ${className}`}
      style={{ aspectRatio: aspectRatio !== "auto" ? aspectRatio : undefined }}
    >
      <div className={`image-reveal-overlay ${isVisible ? "revealed" : ""}`}></div>
      <img 
        src={src} 
        alt={alt}
        className={`image-reveal-image ${isVisible ? "revealed" : ""}`}
        style={{ objectFit }}
      />
    </div>
  );
};

export default ImageReveal;

